import { render, staticRenderFns } from "./TastePanelCreate.vue?vue&type=template&id=6389e6f0&scoped=true&"
import script from "./TastePanelCreate.vue?vue&type=script&lang=js&"
export * from "./TastePanelCreate.vue?vue&type=script&lang=js&"
import style0 from "./TastePanelCreate.vue?vue&type=style&index=0&id=6389e6f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389e6f0",
  null
  
)

export default component.exports